// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2zznl","gfeWrapper":"CalendarEvent_gfeWrapper__3Ft94"};